import { Signal, createSignal } from "solid-js"
import './st-checkbox.css'

export class STCheckboxProps {
    label!: string
    value?: Signal<boolean>
    class?: string
}

export default function STCheckbox(props: STCheckboxProps) {
    const [checked, setChecked] = props.value ?? createSignal(false)


    return <label class={`st-checkbox ${props.class || ''}`}>
        <input type="checkbox" checked={checked()} onChange={(e) => setChecked(e.target.checked)} />
        <span>{props.label}</span>
    </label>
}

STCheckbox.defaultProps = new STCheckboxProps();